// /strategydemo — 免登入產品體驗 DEMO
// 直接共用正式版 AI 策略助理 <StrategySummaryForm demoMode/>，版面 / 樣式 / 插入範例與正式版「同一份」、不會再分岔。
// demoMode 下不接 OpenAI / 後端：摘要由輸入欄位組假文字、回測載本地 fakeKPI、範例與策略組用本地資料、
// 儲存改導向 MasQuant；摘要與回測下方皆有「本頁為產品體驗 DEMO…」提示（見 StrategySummaryForm 的 demoMode 分支）。
import React, { useContext, useEffect } from "react";
import { useMaterialUIController, setLayout } from "context";
import { Box, FormControl, Select, MenuItem, Typography } from "@mui/material";
import { LanguageContext } from "context/LanguageContext";
import MDButton from "components/MDButton";
import StrategySummaryForm from "../strategy/StrategySummaryForm";
import { COLORS } from "theme/tokens";

export default function StrategySummaryDemo() {
  const { language, changeLanguage } = useContext(LanguageContext);
  const [, dispatch] = useMaterialUIController();

  useEffect(() => {
    setLayout(dispatch, "vr"); // DEMO 是公開頁，關掉 dashboard layout
    return () => setLayout(dispatch, "dashboard");
  }, [dispatch]);

  return (
    <Box sx={{ background: COLORS.pageBg || COLORS.grayLightest, minHeight: "100vh" }}>
      {/* 頂部語系選擇器（DEMO 無 navbar，這裡自備一個） */}
      <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1.5} px={3} pt={2}>
        {/* 操作教學：dispatch restartTour → 正式版 form 監聽後重啟導覽（demo 無 navbar，這裡自備） */}
        <MDButton
          variant="gradient"
          color="info"
          size="small"
          onClick={() => window.dispatchEvent(new Event("restartTour"))}
          sx={{ textTransform: "none", fontWeight: "bold", borderRadius: 2 }}
        >
          {language === "zh-CN" ? "📖 操作教学" : (language || "").startsWith("en") ? "📖 Tutorial" : "📖 操作教學"}
        </MDButton>
        <Typography variant="body2" color="text.secondary" fontWeight="bold">
          語言 / Language
        </Typography>
        <FormControl size="small" sx={{ minWidth: 150, bgcolor: COLORS.white, borderRadius: 1.5, boxShadow: 1 }}>
          <Select
            value={language}
            onChange={(e) => changeLanguage(e.target.value)}
            sx={{ fontWeight: "bold", "& .MuiSelect-select": { py: 0.6, px: 1.5 } }}
          >
            <MenuItem value="zh-TW">繁體中文</MenuItem>
            <MenuItem value="zh-CN">简体中文</MenuItem>
            <MenuItem value="en-US">English (US)</MenuItem>
            <MenuItem value="en-GB">English (UK)</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* 共用正式版元件，demoMode 提供假資料 + DEMO 提示 */}
      <StrategySummaryForm demoMode />
    </Box>
  );
}
